import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";

const DashboardV1 = lazy(() => import("./dashboard1/Dashboard1"));
const ProductionDashboard = lazy(() => import("./production_dashboard/ProductionDashboard"));
const EmployeeDashboard = lazy(() => import("./employee_dashboard/EmployeeDashboard"));
const LiveTrackingDashboard = lazy(() => import("./live_tracking/LiveTrackingDashboard"));
const EnhancedLiveTrackingDashboard = lazy(() => import("./enhanced_live_tracking/EnhancedLiveTrackingDashboard"));

const dashboardRoutes = [
  {
    path: "/dashboard/v1",
    element: <DashboardV1 />,
    // auth: authRoles.admin,
  },
  {
    path: "/dashboard/production",
    element: <ProductionDashboard />,
    // auth: authRoles.admin,
  },
  {
    path: "/dashboard/employee",
    element: <EmployeeDashboard />,
  },
  {
    path: "/dashboard/live-tracking",
    element: <LiveTrackingDashboard />,
  },
  {
    path: "/dashboard/enhanced-live-tracking",
    element: <EnhancedLiveTrackingDashboard />,
  },
  {
    path: "/dashboard/enhance-live-tracking",
    element: <EnhancedLiveTrackingDashboard />,
  }
];

export default dashboardRoutes;
